// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__4FCLQ","year":"Footer_year__TY-+2","socials":"Footer_socials__Lo6Y4","bestLogo":"Footer_bestLogo__Xdhx6"};